import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../../services/api"
import type { DiMaDetailsHeaderProps } from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { DetailsHeaderTab } from "../../../../components/Helpers"
import { UserContext } from "../../../../context/UserContext"
import { DeviceRoleGet } from "../../../../models/DeviceRole"
import { DeviceRoleDetails } from "./details_tab/DeviceRoleDetails"
import { DeviceRolePermissions } from "./permissions_tab/DeviceRolePermissions"

export function DeviceRoleContainer() {
  const { user, isLoadingUser } = useContext(UserContext)

  const { deviceId, roleId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [role, setRole] = useState<DeviceRoleGet>()

  const returnURL = `/devices/${deviceId}#roles`

  useEffect(() => {
    if (deviceId && roleId) {
      digitalManagerApi
        .get<DeviceRoleGet>(`/devices/${deviceId}/roles/${roleId}`)
        .then((res) => {
          setRole(res.data)
        })
        .catch((err) => {
          if (err.response.status) {
            navigate(returnURL)
          }
        })
    }
  }, [deviceId, navigate, returnURL, roleId])

  if (!deviceId || !roleId) {
    return <Navigate to="/devices" />
  }

  if (!role || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: role.name,
    label: "Role ID",
    subtitle: role.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTab
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "permissions", label: "Permissions" },
        ]}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && (
        <DeviceRoleDetails
          role={role}
          deviceId={deviceId}
          user={user}
          setRole={setRole}
        />
      )}

      {activeTab === "permissions" && <DeviceRolePermissions />}
    </div>
  )
}
